var React = require('react');

function NextArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.2928 12.7072L29 24L28.2929 23.2929L39.0857 12.5001L-6.76592e-05 12.5001L-6.75718e-05 11.5001L39.0857 11.5001L28.2928 0.707175L28.9999 6.95228e-05L40.2928 11.293L40.2929 11.2929L41 12L40.9999 12.0001L40.2928 12.7072Z","fill":"#ED9C78"}));
}

NextArrowInline.defaultProps = {"viewBox":"0 0 41 24","fill":"none"};

module.exports = NextArrowInline;

NextArrowInline.default = NextArrowInline;
